import Footer from "../components/footer";
import Navbar from "../components/navbar";
import EnergyFeatureSection from "./EnergyFeatureSection";
import ProductDetailPage from "./ProductDetailPage";

const ProductsPage: React.FC = () => {
  return (
    <div className="w-full bg-black min-h-screen">
      <Navbar />
      <ProductDetailPage />
      {/* <EnergyFeatureSection /> */}
      <Footer />
    </div>
  );
};

export default ProductsPage;